const ProfileHeader = () => {
  return (
    <div className="profile-header">
      <div className="cover-gradient" />
      <img
        src="/assets/images/profilepagebg.svg"
        alt="Profile cover"
        className="cover-graphic"
      />
    </div>
  );
};

export default ProfileHeader;
